import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { useWebSocket } from "../../context/WebSocketContext";
import { notify } from "../../utils/notification";

// Escuta o aviso que o backend emite quando uma conversa entra em nível crítico.
// Fica montado fora das telas para valer em qualquer aba do CRM.
const CriticalAnalysisAlerts = ({ onOpenConversation }) => {
  const { messages } = useWebSocket();
  const notified = useRef(new Set());

  useEffect(() => {
    if (!messages.length) return;

    const last = messages[0];
    if (last.type !== "conversation_analysis_alert") return;
    if (notified.current.has(last.id)) return;
    notified.current.add(last.id);

    const alert = last.result || {};
    const open = () => onOpenConversation?.(alert.conversationId);

    toast(
      `Atendimento crítico: ${alert.contactName}`,
      { icon: "🚨", duration: 8000 },
    );

    notify({
      title: `Atendimento crítico: ${alert.contactName}`,
      body: alert.summary?.slice(0, 120) || "A IA classificou esta conversa como crítica.",
      onClick: open,
    });
  }, [messages, onOpenConversation]);

  return null;
};

export default CriticalAnalysisAlerts;
